import React from 'react';
import Button from './Button';
import './Form.css';
import {postRequest} from '../resources/utils/ajax';
import R from 'ramda';
import loadjs from 'loadjs';

class Form extends React.Component {

  constructor() {
    super();
    this.state = {
      disableSubmitButton: false,
      formSubmitting: false,
    }
  }

  componentDidMount() {
    window.recaptchaCallback = () => {
      window.grecaptcha.render('captchaField', {
        'sitekey' : '6Ld4BBcUAAAAAAWk_ISdNLggicmk7Ja7pg3rxkrk'
      });
    }
    loadjs('https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit');
  }

  handleToggleSubmitButton() {
    this.setState(toggleSubmitButton);
  }

  handleToggleFormSubmitting() {
    this.setState(toggleFormSubmitting)
  }

  submitForm(e) {
    e.preventDefault();
    this.handleToggleFormSubmitting();
    const captchaResponse = this.getCaptchaResponse().toString();
    if (R.not(captchaResponse)) {
      return;
    }
    this.handleToggleSubmitButton();
    this.resetCaptcha()
    // const url = 'http://localhost:4567/send_email'
    const url = 'https://lit-crag-48946.herokuapp.com/send_email'
    const data = {
      name: this.name.value,
      email: this.email.value,
      body: this.message.value,
      captchaResponse: captchaResponse
    }
    postRequest(url, data).then((data) => {
      this.handleToggleFormSubmitting();
      if (data.body.email_sent) {
        this.contactForm.reset();
        this.props.toggleFormSubmitted();
        this.props.toggleFormSubmitFail(false);
      } else {
        this.props.toggleFormSubmitFail(true);
      }
    }).catch((err) => {
      console.log(err);
      this.props.toggleFormSubmitFail(true);
      this.handleToggleSubmitButton();
    });
  }

  getCaptchaResponse() {
    return document.querySelector('#g-recaptcha-response').value;
  }

  resetCaptcha() {
    window.grecaptcha.reset();
  }

  render() {
    return (
      <div className='row'>
        <form ref={(input) => this.contactForm = input} onSubmit={(e) => this.submitForm(e)}>
          <span>
            <div className='row'>
              <div className='col span-1-of-3'>
                <label htmlFor='name'>Name</label>
              </div>
              <div className='col span-2-of-3'>
                <input type='text' name='name' id='name' placeholder='Your Name' ref={(input) => this.name = input} required/>
              </div>
            </div>
            <div className='row'>
              <div className='col span-1-of-3'>
                <label htmlFor='email'>Email</label>
              </div>
              <div className='col span-2-of-3'>
                <input type='email' name='email' id='email' placeholder='Your Email' ref={(input) => this.email = input} required/>
              </div>
            </div>
          </span>
          <div className='row'>
            <div className='col span-1-of-3'>
              <label htmlFor='message'>How Can We Help You?</label>
            </div>
            <div className='col span-2-of-3'>
              <textarea name="message" id='message' placeholder='Your message' ref={(input) => this.message = input}></textarea>
            </div>
          </div>
          <div className='row'>
            <div className='col span-1-of-3 form-button-spacing'>
              <label>&nbsp; </label>
            </div>
            <div className='col span-2-of-3'>
              <div className="g-recaptcha" id='captchaField'></div>
              <Button buttonText={'Submit'} buttonType={'input'} disable={R.prop('disableSubmitButton', this.state)}/>
              { this.state.formSubmitting ? <h4>Sending...this may take up to 30 seconds</h4> : ''}
          </div>
          </div>
        </form>
      </div>
    )
  }
}

Form.propTypes = {
  formSubmitFailed: React.PropTypes.bool.isRequired,
  toggleFormSubmitted: React.PropTypes.func.isRequired,
  toggleFormSubmitFail: React.PropTypes.func.isRequired,
}

export default Form;

export function toggleSubmitButton(state, props) {
  return {
    disableSubmitButton: !state.disableSubmitButton
  }
}

export function toggleFormSubmitting(state, props) {
  return {
    formSubmitting: !state.formSubmitting
  }
}



// WEBPACK FOOTER //
// ./src/components/Form.js